import About from "../page/about/About";

export default function AboutHOC({ ...props }) {
  return (
    <>
      <About {...props} />
    </>
  );
}
